import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getHealthMedicalSlice = createSlice({
  name: "getHealthMedical",
  initialState,
  reducers: {
    getHealthMedicalStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getHealthMedicalSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getHealthMedicalFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getHealthMedicalStart,
  getHealthMedicalSuccess,
  getHealthMedicalFailure,
  clearError,
  clearMessage,
} = getHealthMedicalSlice.actions;

export default getHealthMedicalSlice.reducer;
